import { createQueryKeys } from '@lukemorales/query-key-factory';

/**
 * Query keys for Plaid API calls
 *
 * To invalidate ALL plaid queries, use: queries.plaid._def
 */
export const plaid = createQueryKeys('plaid', {
	linkToken: (servicesProviderId: string) => ['linkToken', servicesProviderId],
	bankAccounts: (servicesProviderId: string) => ['bankAccounts', servicesProviderId],
});
